// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3qY_-","messages":"Chat_messages__1iKMF","dateDivider":"Chat_dateDivider__2CRu_"};